import PanelBox from '../../components/PanelBox';
import React, { Component } from 'react'
import { connect } from "react-redux";
import { Progress, message, Spin, Form, Input, Icon, Row, Col, Button, Upload, Select } from 'antd';

import { API_CREATE_JOB, API_CREATE_JOB_LINK_FOR_PLAN, API_JOB_UPLOAD_COMPLETE, API_GET_PLAN_CLOUD_PROVIDER, API_GET_PLAN_TYPE } from '../../config';
import { switch_api } from '../../actions/switch_api';

import ReactDropZone from 'react-dropzone';

import upper from '../../assets/svgicons/upper.svg';
import lower from '../../assets/svgicons/lower.svg';
import dicom from '../../assets/svgicons/dicom.svg';

import { type as app_type } from "../../api.json";

const Option = Select.Option;
const FormItem = Form.Item;
// const Dragger = Upload.Dragger;

const formPatientField = {
  labelCol: { span: 10 },
  wrapperCol: { span: 6 },
};

const formItemFiels = {
  labelCol: { span: 10 },
  wrapperCol: { span: 24 },
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

const parseNames = (name, type) => {
  let res = '';
  const dotParts = name.trim().replace(/\s/g, '_').split('.');
  const parts = dotParts[0].split('_');
  if (parts.indexOf('upper') > -1 || parts.indexOf('u') > -1) {
    res = `upper_${ type }`;
  } else if (parts.indexOf('lower') > -1 || parts.indexOf('l') > -1) {
    res = `lower_${ type }`;
  }
  return `${ res }.${ dotParts[1] }`;
};


class CaseUploadPlanDeepCT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      planCloudProvider: null,
      planType: null,
      fileListUpper: [],
      fileListLower: [],
      fileListDicom: [],
      fileUploadLinks: [],
      fileLoaded: 0,
      fileProgress: 0,
      fileUploading: false,
      patient_id: null,
      complieted_dict: {},
      showFileListUpper: false,
      showFileListLower: false,
      showFileListDicom: false,
    };
    this.uploadProgress = 0;
    this.tryToUpload = this.tryToUpload.bind(this)

    this.createJob = this.createJob.bind(this)
    this.uploadCompliete = this.uploadCompliete.bind(this)
    this.createUploadLink = this.createUploadLink.bind(this)
    // this.sendToSpace = this.sendToSpace.bind(this)
    this.setPatientId = this.setPatientId.bind(this)
    this.incProgress = this.incProgress.bind(this)
    this.toggleShowFileList = this.toggleShowFileList.bind(this)
    this.setPlanType = this.setPlanType.bind(this)
    this.setPlanCloudProvider = this.setPlanCloudProvider.bind(this)

    this.planTypes = [];
    this.getPlanType()
      .then((response) => {
        this.planTypes = response;
        this.forceUpdate();
      });

    this.planCloudProviders = [];
    this.getPlanCloudProvider()
      .then((response) => {
        // if (app_type !== 'standalone') {
        this.planCloudProviders = response;
        this.forceUpdate();
        // }
      });
  }

  setPlanType(e) {
    // this.state.planType = e;
    this.setState({planType: e});
  }

  setPlanCloudProvider(e) {
    // this.state.planCloudProvider = e;
    this.setState({planCloudProvider: e});
  }


  getPlanType() {
    let token =  localStorage.getItem('token')
    return fetch(switch_api(API_GET_PLAN_TYPE), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_GET_PLAN_TYPE }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    // .then((json) => dispatch({type: 'API_GET_PLAN_TYPE', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }


  getPlanCloudProvider() {
    let token =  localStorage.getItem('token')
    return fetch(switch_api(API_GET_PLAN_CLOUD_PROVIDER), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include'
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_GET_PLAN_CLOUD_PROVIDER }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    // .then((json) => dispatch({type: 'GET_PLAN_CLOUD_PROVIDER', json}))
    .catch((e) => {
      // dispatch(userLoggedInFailure('' + e))
    })
  }


  tryToUpload() {
    this.setState({fileUploading:true})
    this.createJob()
  }


  createLinks() {
    // const fileListUpper = this.state.fileListUpper.map((elm) => parseNames(elm.name, 'upper'));
    // const fileListLower = this.state.fileListLower.map((elm) => parseNames(elm.name, 'lower'));
    this.state.fileListDicom.forEach((elm) => (elm._type = 'dicom'));
    const fileListDicom = this.state.fileListDicom.map((elm) => elm.name);

    this.createUploadLink(['upper.stl'], 'upper')
      .then((upperJson) => {
        this.createUploadLink(['lower.stl'], 'lower')
          .then((lowerJson) => {
            this.createUploadLink(fileListDicom, 'dicom')
              .then((dicomJson) => {
                    this.state.fileList = [
                      ...this.state.fileListUpper.map((elm) => new File([elm], 'upper.stl', {type: 'application/vnd.ms-pkistl'})),
                      ...this.state.fileListLower.map((elm) => new File([elm], 'lower.stl', {type: 'application/vnd.ms-pkistl'})),
                      ...this.state.fileListDicom
                    ];
                    this.sendToSpace(upperJson, lowerJson, dicomJson);
              });
          });
      });
  }


  // createJob() {
  //   let token =  localStorage.getItem('token')
  //   return fetch(switch_api(API_GET_PLAN_TYPE), {
  //     method: 'GET',
  //     headers: {
  //       'Accept': 'application/json',
  //       'Authorization': 'Token '+token,
  //       'Content-Type': 'application/json; charset=utf-8'
  //     },
  //     credentials: 'include'
  //   })
  //   .then((response) => {
  //     if (!response.ok) {
  //       console.error("Failed loading { API_GET_PLAN_TYPE }: " + response.statusText);
  //     }
  //     return response;
  //   })
  //   .then((response) => response.json())
  //   .then((json) => {
  //     // const plan_type = json.filter((elm) => elm.name === 'Initial condition')[0].uuid;
  //     fetch(switch_api(API_CREATE_JOB), {
  //       method: 'POST',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Authorization': 'Token '+token,
  //         'Content-Type': 'application/json; charset=utf-8'
  //       },
  //       credentials: 'include',
  //       body: JSON.stringify({
  //         'patient_tag': this.state.patient_id,
  //         'plan_type': this.state.planType,
  //         'plan_cloud_provider': this.state.planCloudProvider,
  //         'flow': this.props.user.flow.filter((elm) => (elm.type === 'teeth_alignment_modelling'))[0].uuid
  //       })
  //     })
  //     .then((response) => {
  //       if (!response.ok) {
  //         console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
  //       }
  //       return response;
  //     })
  //     .then(() => this.createLinks())
  //   })
  //   .catch((e) => {
  //     // dispatch(userLoggedInFailure('' + e))
  //   })
  // }


  createJob() {
    let token = localStorage.getItem('token')
    fetch(switch_api(API_CREATE_JOB), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify({
        'patient_tag': this.state.patient_id,
        'plan_cloud_provider': this.state.planCloudProvider,
        'plan_type': this.state.planType,
        'flow': this.props.user.flow.filter((elm) => (elm.type === 'ram_single_control_point'))[0].uuid
      })
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
      }
      return response;
    })
    .then(() => this.createLinks())
  }


  //TODO: Move to action/jobs
  // createJob(plan_type) {
  //   let token = localStorage.getItem('token')
  //   fetch(switch_api(API_CREATE_JOB), {
  //     method: 'POST',
  //     headers: {
  //       'Accept': 'application/json',
  //       'Authorization': 'Token '+token,
  //       'Content-Type': 'application/json; charset=utf-8'
  //     },
  //     credentials: 'include',
  //     body: JSON.stringify({
  //       'patient_tag': this.state.patient_id,
  //       plan_type,
  //       'plan_cloud_provider': this.state.planCloudProvider,
  //       'flow': this.props.user.flow.filter((elm) => (elm.type === 'plan_deep_ct'))[0].uuid
  //     })
  //   })
  //   .then((response) => {
  //     if (!response.ok) {
  //       console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
  //     }
  //     return response;
  //   })
  //   .then(() => this.createLinks())
  // }


  createUploadLink(files, folder) {
    let token =  localStorage.getItem('token')
    return fetch(switch_api(API_CREATE_JOB_LINK_FOR_PLAN), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: JSON.stringify({ files, folder })
    })
    .then((response) => {
      if (!response.ok) {
        console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
      }
      return response;
    })
    .then((response) => response.json())
    .catch((e) => {
      console.warn(e)
    })
  }

  uploadCompliete() {
    let token =  localStorage.getItem('token')
    fetch(switch_api(API_JOB_UPLOAD_COMPLETE), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Token '+token,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
    })
  }


  sendToSpace(upperJson, lowerJson, dicomJson) {
    const ComplietedDict = {}
    if (upperJson && lowerJson && dicomJson) {
      this.state.fileList.forEach((file) => {
        upperJson.map((link_item)=>link_item.filename == file.name ? ComplietedDict['upper_' + link_item.filename]={'link':link_item.link,'file':file} : null);
        lowerJson.map((link_item)=>link_item.filename == file.name ? ComplietedDict['lower_' + link_item.filename]={'link':link_item.link,'file':file} : null);
        dicomJson.map((link_item)=>link_item.filename == file.name ? ComplietedDict['dicom_' + link_item.filename]={'link':link_item.link,'file':file} : null);
      });
    }
    this.setState({'complieted_dict':ComplietedDict})
    this.sendFile()
  }

  incProgress() {
    if (this.state.fileProgress != this.state.fileList.length) {
      this.setState({fileProgress:this.state.fileProgress+1})
      this.sendFile()
    }
  }

  sendFile() {
    let fileList = this.state.complieted_dict
    if (Object.keys(fileList).length) {
      let fileItem = Object.keys(fileList)[0]
      let URL = fileList[fileItem]['link']
      let file = fileList[fileItem]['file']
      let blob = new Blob([file], {type: file.type});
      fetch(URL, {
        method: 'PUT',
        body: blob
      })
      .then((response) => {
        if (!response.ok) {
          console.error("Failed loading { API_CREATE_LINK }: " + response.statusText);
          message.error('Upload Failed', 5);
        }
        return response;
      })
      // .then((response) => console.warn(response))
      .then(()=>{
        delete fileList[fileItem]
        this.setState({complieted_dict:fileList})
        this.incProgress()

        if (this.state.fileProgress == this.state.fileList.length) {
          this.setState({fileUploading:false,fileProgress:0,fileList:[],patient_id:null});
          message.success('Files have been uploaded!', 5);
          this.uploadCompliete();
          setTimeout(() => {
            this.props.history.push('/home');
          }, 100);
        }
      })
      .catch((e) => {
        console.warn(e)
        message.error('Upload Failed');
        this.setState({fileUploading:false,fileProgress:0})
      })
    }
  }

  setPatientId(data) {
    this.setState({'patient_id':data})
  }

  toggleShowFileList(showFileList) {
    const obj = {};
    obj[showFileList] = !this.state[showFileList];
    this.setState(obj)
  }

  renderUploadItem(fileList, format, icon, name, showFileList) {
    return (
      <FormItem {...formItemFiels} style={{padding: '0 5px 0 5px', marginBottom: '0'}}>
      <ReactDropZone
          accept={format}
          multiple={name.toLowerCase() === 'dicom' ? true : false}
          id={`${ name }-dropzone`}
          onDrop={(e) => {
            this.setState((state) => {
              const obj = {};
              obj[fileList] = e.map((elm, i) => {
                elm.uid = i;
                return elm;
              });
              return obj;
            });
          }}
          style={{
            border: '1px dashed #d9d9d9',
            transition: 'border-color 0.3s',
            cursor: 'pointer',
            borderRadius: '4px',
            textAlign: 'center',
            width: '100%',
            height: '100%',
            position: 'relative',
            padding: '16px 0',
            background: '#fafafa'
          }}
        >
          <p className="ant-upload-drag-icon">
            {icon ? <img src={icon} style={{width: '100px'}} /> : <Icon type="inbox" />}
          </p>
          <p className="ant-upload-text" style={{margin: 10}}>Drag to upload {name} files</p>
        </ReactDropZone>
        {/* <Dragger
          accept={format}
          disabled={this.state.fileUploading}
          multiple
          processData={false}
          beforeUpload = {(file) => {
            this.setState((state) => {
              const obj = {};
              obj[fileList] = [...state[fileList], file];
              return obj;
            });
            return false;
          }}
        >
          <p className="ant-upload-drag-icon">
              <img src={icon} style={{width: '100px'}} />
          </p>
          <p className="ant-upload-text" style={{margin: 10}}>Drag to upload {name} files</p>
        </Dragger> */}
        {this.state[fileList].length ?
          <div className={'ant-upload-list-box'}>
          <div style={{'cursor':'pointer', display:'flex', justifyContent: 'space-between', alignItems: 'center', margin: 10}} onClick={()=>this.toggleShowFileList(showFileList)}>
            <div>
              <Icon type="copy" style={{margin: 5}}/>
                files ({this.state[fileList].length})
              </div>
            { <Icon type={this.state[showFileList] ? "caret-down" : "caret-right" }/> }
          </div>
            {this.state[showFileList] && <Upload fileList={this.state[fileList]}
                                                onRemove = {(file) => {
                                                  this.setState((state) => {
                                                    const index = state[fileList].indexOf(file);
                                                    const newFileList = state[fileList].slice();
                                                    newFileList.splice(index, 1);
                                                    const obj = {};
                                                    obj[fileList] = newFileList;
                                                    return obj;
                                                  });
                                                }}></Upload>}
          </div> : null}
      </FormItem>
    );
  }

  render() {
    if (!(this.state.fileList.length === 0 && this.uploadProgress > 0)) {
      this.uploadProgress = Math.round(this.state.fileProgress * 100 / this.state.fileList.length);
    }

    return (
      <PanelBox title={"Case Upload"}>
        <Row type="flex" justify="center">
          <FormItem
            {...formPatientField}
            label="Patient id"
            hasFeedback
          >
            <Input
              prefix={<Icon type="user" style={{ fontSize: 13 }} />}
              id="patient-id-input"
              value={this.state.patient_id ? this.state.patient_id : ""}
              onChange={(e) => this.setPatientId(e.target.value)}
              disabled={this.state.fileUploading}
              style={{ width: 100 }}/>
          </FormItem>
        </Row>
        <Row type="flex" justify="center" style={{display: 'inline-flex'}}>
          {this.renderUploadItem('fileListUpper', '.stl', upper, 'upper', 'showFileListUpper')}
          {this.renderUploadItem('fileListLower', '.stl', lower, 'lower', 'showFileListLower')}
          {this.renderUploadItem('fileListDicom', [ '.dcm', '.dicom' ], dicom, 'DICOM', 'showFileListDicom')}
          <Row style={{width: 'calc(100% - 42px)', marginBottom: '24px', padding: '0 20px 0 22px'}}>
            {Boolean(this.uploadProgress) ? <Progress percent={this.uploadProgress} id="upload-progress" strokeWidth={5} /> : null}
          </Row>
        </Row>
        <Row type="flex" justify="center">
          <FormItem>
            {this.planTypes.length ?
              <Select disabled={this.state.fileUploading} id="plan-type-selector" defaultValue="selectPlanType" onChange={this.setPlanType}>
                <Option selected disabled value="selectPlanType" key="selectPlanType">Select Plan Type</Option>
                {this.planTypes.map((elm, i) => (
                  <Option value={elm.uuid} id={`plan-type-option-${ i }`} key={elm.uuid}>{elm.name}</Option>
                ))}
              </Select>
            : null}
          </FormItem>
        </Row>
        <Row type="flex" justify="center">
          <FormItem>
            {this.planCloudProviders.length ?
              <Select disabled={this.state.fileUploading} id="plan-cloud-provider-selector" defaultValue="selectPlanCloudProviders" onChange={this.setPlanCloudProvider}>
                <Option selected disabled value="selectPlanCloudProviders" key="selectPlanCloudProviders">Select Plan Cloud Provider</Option>
                {this.planCloudProviders.map((elm, i) => (
                  <Option value={elm.uuid} id={`plan-cloud-provider-option-${ i }`} key={elm.uuid}>{elm.name}</Option>
                ))}
              </Select>
            : null}
          </FormItem>
        </Row>
        <Row type="flex" justify="center">
          <Button
            loading={this.state.fileUploading}
            className="upload-demo-start"
            id="submit-new-case-button"
            type="primary"
            onClick={this.tryToUpload}
            disabled={(this.state.fileListUpper.length && this.state.fileListLower.length) && this.state.fileListDicom.length && this.state.planType && this.state.planCloudProvider && this.state.patient_id ? false : true}
          >
            Start Upload
          </Button>
        </Row>
      </PanelBox>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseUploadPlanDeepCT)


// WEBPACK FOOTER //
// ./src/views/Cases/caseUploadRAMSingleControlPoint.jsx